import { useRef } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_TQC2011_R01 } from "./Content_TQC2011_R01";
import { DetailTable_TQC2011_R01 } from "./DetailTable_TQC2011_R01";
import { HeaderTable_TQC2011_R01 as Table_TQC2011_R01 } from "./Table_TQC2011_R01";
import { Info_TQC2011_R01 } from "./Info_TQC2011_R01";
import { SearchSection_TQC2011_R01 } from "./SearchSection_TQC2011_R01";

const TABLE_INFO_RESIZER = {
	code: "TQC2011_R01",
	type: "height" as const,
	storageKey: "TQC2011_R01-table-info-split-height",
	min: 25,
	max: 80,
	default: 55,
};

const INFO_DETAIL_RESIZER = {
	code: "TQC2011_R01",
	type: "height" as const,
	storageKey: "TQC2011_R01-info-detail-split-height",
	min: 15,
	max: 70,
	default: 35,
};

export const Container_TQC2011_R01 = () => {
	useFetchActionbarAuth("TQC2011_R01");
	const containerRef = useRef<HTMLDivElement>(null);
	const bottomPanelRef = useRef<HTMLDivElement>(null);
	const infoPanelRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);
	const isInfoDetailResizing = useRef(false);

	const { splitValue, handleMouseDown } = useMouseContent({
		resizer: TABLE_INFO_RESIZER,
		isResizing,
		containerRef,
	});

	const {
		splitValue: infoDetailSplitValue,
		handleMouseDown: handleInfoDetailMouseDown,
	} = useMouseContent({
		resizer: INFO_DETAIL_RESIZER,
		isResizing: isInfoDetailResizing,
		containerRef: bottomPanelRef,
		infoRef: infoPanelRef,
	});

	const {
		fetchData,
		handleHeaderRowClick,
		handleInspectTypeChange,
		handleSaveClick,
		handleDeleteClick,
		handleExcelClick,
		handlePrintClick,
		initContainerData,
	} = Content_TQC2011_R01();

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={() => undefined}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onPrintClick={handlePrintClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_TQC2011_R01 />
			<div
				className="flex flex-col flex-1 p-[12px] gap-[4px] min-h-0"
				ref={containerRef}
			>
				<div style={{ height: `${splitValue}%` }}>
					<Table_TQC2011_R01
						onHeaderRowClick={handleHeaderRowClick}
					/>
				</div>

				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300 flex-shrink-0"
					onMouseDown={(event) => handleMouseDown("UD", event.nativeEvent)}
					onDragStart={(event) => event.preventDefault()}
				/>

				<div
					ref={bottomPanelRef}
					className="flex flex-col gap-[4px]"
					style={{ height: `${100 - splitValue}%` }}
				>
					<div
						ref={infoPanelRef}
						style={{
							height: `${infoDetailSplitValue}%`,
							maxHeight: `${infoDetailSplitValue}%`,
						}}
					>
						<Info_TQC2011_R01
							onInspectTypeChange={handleInspectTypeChange}
						/>
					</div>
					<div
						className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
						onMouseDown={(event) =>
							handleInfoDetailMouseDown("UD", event.nativeEvent)
						}
					/>
					<div style={{ height: `${100 - infoDetailSplitValue}%` }}>
						<DetailTable_TQC2011_R01 />
					</div>
				</div>
			</div>
			<Message />
		</div>
	);
};

export default Container_TQC2011_R01;
